import type { SVGAttributes } from 'react'

/**
 * Cottonray 브랜드 마크 — `frontend/cottonray/brand/icon.svg` 와 같은 도형이다.
 * `C` 는 Cottonray 의 이니셜, 뻗어 나가는 두 줄기는 ray(빛)다.
 * 이름 자체가 상호 **솜날**의 직역이라(솜=cotton, 날=ray) 그 뜻을 그대로 형태로 옮겼다.
 *
 * **파일을 import 하지 않고 인라인으로 둔다.** icon.svg 에는 `#3559e9`(accent-500)가 박혀 있어
 * `<img>` 로 넣으면 라이트·다크 어느 쪽 액센트와도 어긋난다 — 여기서는 `currentColor` 로 받아
 * `.st-brand-mark` 가 주는 `--st-color-accent` 를 따라간다.
 *
 * viewBox 가 `0 0 512` 가 아닌 이유: 512 상자 안에서 획이 실제로 차지하는 넓이는
 * (42.96, 89.28)에서 415.04×354 뿐이고 나머지는 앱 아이콘 타일용 여백이다. 글자 옆에
 * 놓을 때는 그 여백을 잘라내야 크기가 맞아 획의 경계를 그대로 viewBox 로 쓴다.
 *
 * **경계는 획의 바깥선까지다** — 굽은 획의 겉넓이는 중심선 좌표로 눈대중할 수 없다.
 * C 의 원호는 중심 (245.96, 266.28)·반지름 148 이고 획 두께가 58 이라 바깥선은
 * 반지름 177 까지 나간다. 여기에 round 캡까지 더한 값이 위 경계다. 처음엔 이걸 빼먹고
 * `53 79 405 354` 로 뒀다가 C 의 왼쪽과 아래가 10 단위씩 잘려 평평해졌었다.
 * 1 단위는 렌더러 반올림 여유다.
 *
 * 회사 홈페이지(`cottonray.com`)와 운영 콘솔(`admin.cottonray.com`)이 같은 마크를 쓰므로
 * 여기 공용으로 둔다 — 도형을 두 벌 두면 한쪽만 낡는다.
 */
export function BrandMark({ className, ...rest }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      className={className === undefined ? 'st-brand-mark' : `st-brand-mark ${className}`}
      viewBox="42 88 417 357"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <g transform="translate(-26 0)" fill="none" stroke="currentColor" strokeLinecap="round">
        <path d="M340 152a148 148 0 1 0 28 198" strokeWidth="58" />
        <path d="M330 206 L462 140" strokeWidth="44" />
        <path d="M336 292 L420 250" strokeWidth="44" />
      </g>
    </svg>
  )
}
